import VueAdsense from './v-adsense'

VueAdsense.install = function install (Vue) {
  Vue.component(VueAdsense.name, VueAdsense)
}

export default VueAdsense



// WEBPACK FOOTER //
// ./src/vendor-components/v-adsense/index.js